import React from 'react';
import classnames from 'classnames';
import Isvg from 'react-inlinesvg';
import { Link } from 'react-router-dom';
import NavLink from 'app/components/general/NavLink';
import InputGroupBlock from 'app/components/general/InputGroupBlock';
import { validate as uuidValidate } from 'uuid';
import {
  Collapse, Navbar, Nav, NavItem, Tooltip,
} from 'reactstrap';
import TeammoLogo from 'app/images/logo-white.svg';

import HomeIcon from 'app/images/icons/home.svg';
import ProfileIcon from 'app/images/icons/person.svg';
import HelpIcon from 'app/images/icons/help.svg';
import LogoutIcon from 'app/images/icons/logout.svg';
import DownArrow from 'app/images/icons/down-arrow.svg';
import DotsIcon from 'app/images/icons/dots.svg';
import EventsIcon from 'app/images/icons/events.svg';
import TeamIcon from 'app/images/icons/team.svg';
import TeamMemberIcon from 'app/images/icons/person.svg';
import TeamsIcon from 'app/images/icons/teams.svg';
import RequestIcon from 'app/images/icons/request.svg';
import ReportsIcon from 'app/images/icons/reports.svg';
import ClipboardIcon from 'app/images/icons/clipboard.svg';
import PayoutsIcon from 'app/images/icons/bank.svg';

interface INavBarProps {
  actions: any;
  match: any;
  teams: any;
  users: any;
  teamName: string;
  teamId: string;
  clubs: any;
  clubName: string;
  clubId: string;
  authentication: any;
}

interface INavBarState {
  isOpen: boolean;
  tooltipOpen: boolean;
  profileOpen: boolean;
}
class NavBar extends React.Component<INavBarProps, INavBarState> {
  static defaultProps = {
    actions: {},
    users: {},
    match: {},
    teams: {},
    teamName: '',
    teamId: '',
    clubs: {},
    clubName: '',
    clubId: '',
  };

  state = {
    isOpen: true,
    tooltipOpen: false,
    profileOpen: false,
  };

  toggleTooltip = () => {
    if (!this.props.teams.currentTeam.connectedToAssociation) {
      this.setState((previousState) => ({
        tooltipOpen: !previousState.tooltipOpen,
      }));
    }
  };

  toggleProfileOpen = () => {
    this.setState((previousState) => ({
      profileOpen: !previousState.profileOpen,
    }));
  };

  handleUserChange = (e): void => {
    if (e && uuidValidate(e?.target?.value)) {
      this.props.actions.switchUser(
        e?.target.value,
      );
    }
  }

  renderSudoSelector = (): React.ReactNode => (
    <div className="sudo-switch-user">
      <InputGroupBlock
        type="text"
        name="user"
        placeholder="User ID"
        aria-label="User ID"
        inputGroupClassName="no-margin-bottom"
        autoComplete="off"
        value={this.props.authentication.userId}
        onChange={this.handleUserChange}
      />
    </div>
  );

  render(): React.ReactNode {
    const featureFlags = this.props.users?.currentUser?.featureFlags;
    const teammoAdmin = this.props.users?.currentUser?.roleType === 'teammo-admin';
    const bolShowReports = false; // teammoAdmin || featureFlags?.showReports || true;

    return (
      <Navbar className="side-bar">
        <Link className="navbar-brand" to="/dashboard">
          <Isvg className="header-logo" alt="Teammo" src={TeammoLogo} />
          {this.props.users.currentUser.userType === 'club' && (
            <div className="header-logo-icon">Club</div>
          )}
        </Link>
        <Collapse isOpen={this.state.isOpen} navbar>
          <Nav className="" navbar>
            {this.props.authentication?.teammoAdminUser && this.renderSudoSelector()}
            {/* {this.props.users.currentUser.userType === 'team'
              && this.renderTeamsSelector()}
            {this.props.users.currentUser.userType === 'club'
              && this.renderClubsSelector()} */}
            <div className="nav-top">
              <NavItem>
                <NavLink
                  className={classnames({
                    active:
                      this.props.match.path === '/dashboard'
                      || this.props.match.path === '/',
                  })}
                  to="/dashboard"
                >
                  <Isvg className="nav-link-icon" src={HomeIcon} />
                  <span className="nav-link-text">My Dashboard</span>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: this.props.match.path.includes('/payment-requests'),
                  })}
                  to="/payment-requests"
                >
                  <Isvg className="nav-link-icon" src={RequestIcon} />
                  <span className="nav-link-text">Payment Requests</span>
                </NavLink>
              </NavItem>
              {this.props.users.currentUser.userType === 'team' && (
                <NavItem
                  id="upcoming-matches-nav-side"
                >
                  <NavLink
                    className={classnames({
                      active: this.props.match.path.includes('/list-payments'),
                    })}
                    to="/list-payments"
                  >
                    <Isvg className="nav-link-icon" src={EventsIcon} />
                    <span className="nav-link-text">Matches</span>
                  </NavLink>
                </NavItem>
              )}
              {this.props.users.currentUser.userType === 'team' && (
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: this.props.match.path.includes('/teams'),
                    })}
                    to="/teams"
                  >
                    <Isvg className="nav-link-icon" src={TeamIcon} />
                    <span className="nav-link-text">Teams</span>
                  </NavLink>
                </NavItem>
              )}
              {this.props.users.currentUser.userType === 'team' && (
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: this.props.match.path.includes('/team-members'),
                    })}
                    to="/team-members"
                  >
                    <Isvg className="nav-link-icon" src={TeamMemberIcon} />
                    <span className="nav-link-text">Team Members</span>
                  </NavLink>
                </NavItem>
              )}
              <NavItem>
                <NavLink
                  className={classnames({
                    active: this.props.match.path === '/payouts',
                  })}
                  to="/payouts"
                >
                  <Isvg className="nav-link-icon" src={PayoutsIcon} />
                  <span className="nav-link-text">Payouts</span>
                  {/* <div className="nav-connection-indicator" /> */}
                </NavLink>
              </NavItem>
              {bolShowReports && (
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: this.props.match.path === '/reports',
                    })}
                    to="/reports"
                  >
                    <Isvg className="nav-link-icon" src={ReportsIcon} />
                    <span className="nav-link-text">Reports</span>
                    {/* <div className="nav-connection-indicator" /> */}
                  </NavLink>
                </NavItem>
              )}
            </div>
            <div className="nav-bottom">
              <NavItem>
                <a
                  className={classnames('nav-link nav-parent-item', {
                    active: (this.props.match.path.includes('/profile') || this.state.profileOpen),
                  })}
                  // to="/profile/info"
                  onClick={this.toggleProfileOpen}
                >
                  <Isvg className="nav-link-icon" src={ProfileIcon} />
                  <span className="nav-link-text">My Profile</span>
                  <Isvg className="nav-down-arrow" src={DownArrow} />
                </a>
              </NavItem>
              <div
                className={classnames('nav-sub-group', {
                  'd-none': !(this.props.match.path.includes('/profile') || this.state.profileOpen),
                })}
              >
                <NavItem>
                  <NavLink
                    className={classnames({
                      active:
                        this.props.match.url === '/profile'
                        || this.props.match.url === '/profile/info',
                    })}
                    to="/profile"
                  >
                    My Details
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: this.props.match.url === '/profile/bank',
                    })}
                    to="/profile/bank"
                  >
                    Bank Details
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: this.props.match.url === '/profile/payment-methods',
                    })}
                    to="/profile/payment-methods"
                  >
                    Payment Methods
                  </NavLink>
                </NavItem>
              </div>
              <NavItem>
                <a
                  className="nav-link"
                  href="https://help.teammo.com.au/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Isvg className="nav-link-icon" src={HelpIcon} />
                  <span className="nav-link-text">Help & Support</span>
                </a>
              </NavItem>
              <NavItem>
                <a
                  className="nav-link"
                  href=""
                  onClick={(e) => {
                    e.preventDefault();
                    this.props.actions.logoutUser();
                  }}
                >
                  <Isvg className="nav-link-icon" src={LogoutIcon} />
                  <span className="nav-link-text">Logout</span>
                </a>
              </NavItem>
            </div>
          </Nav>
        </Collapse>
      </Navbar>
    );
  }
}
export default NavBar;
